<template>
  <v-list class="pt-20 text-left mh100">
    <h2 class="ml-3">Credit Score</h2>
    <v-divider></v-divider>
    <br />
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Previous Score :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{
              creditScore && creditScore.previous_score
                ? Math.round(creditScore.previous_score * 100) / 100
                : "-"
            }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Actual Score :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{
              creditScore && creditScore.credit_score
                ? Math.round(creditScore.credit_score * 100) / 100
                : "-"
            }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Showing Score :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{
              creditScore && creditScore.showing_score
                ? Math.round(creditScore.showing_score * 100) / 100
                : "-"
            }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm5>
          <h5>Status :</h5>
        </v-flex>
        <v-flex sm7>
          <v-list-tile-content>
            {{
              creditScore && creditScore.credit_score_status
                ? creditScore.credit_score_status
                : "-"
            }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
  </v-list>
</template>
<script>
  export default {
    props: ["creditScore"],
  };
</script>
